import type { ServiceGroup } from "@prisma/client";
import List from "~/ui/List";
import SubtleAccordion from "~/ui/SubtleAccordion";
import isEmpty from "~/kernel/arrays/isEmpty";
import ServiceListItem from "./ServiceListItem";
import type { ServiceGroupViewObject } from "./buildServicesViewObject";

type ServiceGroupProps = {
  defaultOpen: boolean;
  group: ServiceGroupViewObject;
};

export default function ServiceGroup({
  group,
  defaultOpen,
}: ServiceGroupProps) {
  if (isEmpty(group.services)) {
    return null;
  }

  return (
    <SubtleAccordion summary={group.name} defaultOpen={defaultOpen}>
      <List>
        {group.services.map((service) => (
          <ServiceListItem key={service.id} service={service} />
        ))}
      </List>
    </SubtleAccordion>
  );
}
